import React from "react";

export default function Dimension({ id, reducir, color, rotate, set }) {
  const Setiqueta = {
    position: "absolute",
    transform: rotate,
    background: color,
    fontSize: "2.7vh",
    fontWeight: 700,
    height: "5vh",
    textAlign: "center",
    borderRadius: "10px",
    border: "2px ridge #424242",
    color: "#2e2e2e",
    cursor: "pointer"
  };

  function selecciono() {
    reducir();
    set(id);
  }
  return (
    <div
      id={id}
      style={Setiqueta}
      onClick={() => selecciono()}
      onMouseEnter={(e) => (e.currentTarget.style.transform = `${rotate} scale(1.1)`)}
      onMouseLeave={(e) => (e.currentTarget.style.transform = `${rotate} scale(1)`)}
    >
      {id}
    </div>
  );
}
